import { render, staticRenderFns } from "./PlanejamentoContratoListFiltros.vue?vue&type=template&id=85b20d1c"
import script from "./PlanejamentoContratoListFiltros.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoListFiltros.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoListFiltros.vue?vue&type=style&index=0&id=85b20d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports